import * as React from 'react';

export const SlimDocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		version="1.1"
		viewBox="0 0 1200 1200"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		fill="currentColor"
	>
		<g fill="#059">
			<path d="m402 246h468v48h-468z" />
			<path d="m330 354h540v48h-540z" />
			<path d="m330 462h540v48h-540z" />
			<path d="m330 570h540v48h-540z" />
			<path d="m330 678h348v48h-348z" />
			<path d="m348 60c-66.273 0-120 53.727-120 120v840c0 66.273 53.727 120 120 120h504c66.273 0 120-53.727 120-120v-840c0-66.273-53.727-120-120-120zm0 36h504c46.391 0 84 37.609 84 84v840c0 46.391-37.609 84-84 84h-504c-46.391 0-84-37.609-84-84v-840c0-46.391 37.609-84 84-84z" />
		</g>
	</svg>
);
